import { store } from "store/store"
export {
  resolveServiceEndpoint,
  validatePlatformServiceEndpoints,
} from "./platformServiceEndpoints"

type ClerkWindow = Window & {
  Clerk?: {
    session?: {
      getToken: (params: { template: string }) => Promise<string | null>
    }
  }
}

export const getClerkAppsyncToken = async () => {
  try {
    const clerk = (window as ClerkWindow).Clerk
    if (!clerk?.session?.getToken) return null

    return await clerk.session.getToken({ template: "appsync" })
  } catch {
    return null
  }
}

export const getClerkBearerToken = async (serviceName: string) => {
  const token = await getClerkAppsyncToken()
  if (!token) throw new Error(`Unable to resolve Clerk token for ${serviceName}`)
  return token
}

export const getPlatformHeaders = async (contentType?: string) => {
  const token = await getClerkBearerToken("platform request")
  const merchantId = store.getState().user.userInfo.merchantId.trim()
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  }

  if (contentType) headers["Content-Type"] = contentType
  if (merchantId) headers["X-Tint-Merchant-Id"] = merchantId

  return headers
}
